import React from 'react';
import { ServerSecurity } from './ServerSecurity';
import { Markdown, Schema, Bindings } from '../../components';
import { useConfig } from '../../contexts';
import { CommonHelpers, SchemaHelpers } from '../../helpers';
export var Server = function (_a) {
    var serverName = _a.serverName, server = _a.server;
    var config = useConfig();
    if (!server) {
        return null;
    }
    var urlVariables = SchemaHelpers.serverVariablesToSchema(server.variables());
    var protocolVersion = server.protocolVersion();
    var serverRequirements = server.security();
    return (React.createElement("div", { className: "panel-item" },
        React.createElement("div", { className: "panel-item--center px-8" },
            React.createElement("div", { className: "shadow rounded bg-gray-200 p-4 border bg-gray-100" },
                React.createElement("div", null,
                    React.createElement("span", { className: "font-mono text-base" }, server.url()),
                    React.createElement("span", { className: "bg-teal-500 font-bold no-underline text-white uppercase rounded mx-2 px-2 py-1 text-sm" }, protocolVersion
                        ? server.protocol() + " " + protocolVersion
                        : server.protocol()),
                    React.createElement("span", { className: "bg-blue-500 font-bold no-underline text-white uppercase rounded px-2 py-1 text-sm" }, serverName)),
                server.hasDescription() && (React.createElement("div", { className: "mt-2" },
                    React.createElement(Markdown, null, server.description()))),
                urlVariables && (React.createElement("div", { className: "mt-2", id: "" + CommonHelpers.getIdentifier("server-" + serverName + "-url-variables", config) },
                    React.createElement(Schema, { schemaName: "URL Variables", schema: urlVariables, expanded: true }))),
                serverRequirements && (React.createElement("div", { id: "" + CommonHelpers.getIdentifier("server-" + serverName + "-security", config) },
                    React.createElement(ServerSecurity, { serverRequirements: serverRequirements }))),
                server.hasBindings() && (React.createElement("div", { className: "mt-2" },
                    React.createElement(Bindings, { bindings: server.bindings() }))))),
        React.createElement("div", { className: "panel-item--right" })));
};
//# sourceMappingURL=Server.js.map